import React from "react";
import { Form, Button, Radio, Space } from "antd";
import { ReactSVG } from "react-svg";
import { useSelector } from "react-redux";

import { getTranslation } from "../../../utils/helper";
import { ROUTE_PLAN_TYPIES } from "../../../constants";

const OrderTypeForm = ({ form, handleSubmit, handleCancel }) => {
  const user = useSelector(state => state.auth.user);
  const setting = user.company;

  return (
    <div className="OrderTypeForm">
      <Form form={form} scrollToFirstError layout="vertical" hideRequiredMark colon={false} onFinish={handleSubmit}>
        <div className="FormHeader">
          <div className="left">{getTranslation(setting, "Orders", "Select Order Type")}</div>
        </div>
        <div className="FormContent">
          <Form.Item label={false} name="type" rules={[{ required: true, message: "Required" }]}>
            <Radio.Group className="RoutePlanTypeRadio">
              <Space direction="vertical">
                {ROUTE_PLAN_TYPIES.map(item => (
                  <Radio key={item.value} value={item.value}>
                    <ReactSVG className="icon" src={`/icons/${item.value.toLowerCase()}.svg`} />
                    {getTranslation(setting, "Route Plans", item.name)}
                  </Radio>
                ))}
              </Space>
            </Radio.Group>
          </Form.Item>
        </div>
        <div className="FormFooter">
          <div className="Left"></div>
          <div className="Right">
            <Button key="cancel" onClick={handleCancel}>
              {getTranslation(setting, "Common", "Cancel")}
            </Button>
            <Button htmlType="submit" type="primary">
              {getTranslation(setting, "Common", "Continue")}
              <ReactSVG className="icon" src="/icons/arrow-view.svg" />
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default OrderTypeForm;
